/*
 * Copyright (c) CIRROM 2025.
 */

import { Card as MuiCard, CardContent as MuiCardContent } from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { MiraTheme } from "../../theme/theme";
import { css } from "@emotion/react";
import { rgba } from "polished";

export const MiraCard = styled(MuiCard)(spacing);

export const MiraCardContent = styled(MuiCardContent)<{ theme?: MiraTheme }>`
  &:last-child {
    padding-top: 0;
    padding-bottom: ${(props) => props.theme.spacing(4)};
  }
`;

const illustrationCardStyle = (props: any) => css`
  ${props.illustration &&
  props.theme.palette.mode !== "dark" &&
  `
    background: ${rgba(props.theme.palette.primary.main, 0.125)};
    color: ${props.theme.palette.primary.main};
  `}
`;

export const RelativeCard = styled(MuiCard)<{ illustration?: string }>`
  position: relative;

  ${illustrationCardStyle}
`;

export const RelativeClickableCard = styled(MuiCard)<{}>`
  cursor: pointer;
`;

export const RelativeAnimatedClickableCard = styled(MuiCard)<{
  theme?: MiraTheme;
}>`
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 0;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: ${(props) => props.theme.palette.primary.main};
  }
`;

export const RelativeCardContent = styled(MuiCardContent)<{
  theme?: MiraTheme;
}>`
  position: relative;
  min-width: 0;

  & .MuiTypography-root {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover .MuiTypography-root {
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  &:last-child {
    padding-bottom: ${(props) => props.theme.spacing(4)};
  }
`;
